<template>
	<v-card
		outlined
	>
		<v-card-title
			class="text_primary"
		>
			{{ page_title }}

			<v-spacer></v-spacer>

		</v-card-title>

		<v-divider></v-divider>
        
		<v-row class="mt-1 mb-1 pr-3">
			<v-col
				cols="12"
				lg="8"
				md="12"
				xs="12"
			>
                <v-card-text
                    class="d-flex align-center pl-4 ml-0 pt-0 pr-0 pb-0"
                >
                    <v-select
                        style="max-width:12em;"
                        outlined
                        return-object
                        v-model="selected_target"
                        :items="targets"
                        hide-details
                        dense
                        class="mr-3"
                        @change="changeType"
                    >
                    </v-select>
                </v-card-text>
			</v-col>
            <v-col
                cols="12"
                lg="4"
                md="12"
                xs="12"
            >  
                <v-card-text
                    class="d-flex align-center justify-end pa-0"
                >
                    <p class="mb-0 pb-0 mr-3">顯示</p>
                    <v-select
                        style="max-width:7em;"
                        outlined
                        return-object
                        @change="chagePerPage(selected_per_page)"
                        v-model="selected_per_page"
                        :items="per_page_items"
                        item-value="value"
                        item-text="name"
                        hide-details
                        dense
                    >
                    </v-select>
                </v-card-text>
            </v-col>
		</v-row>

        <v-divider></v-divider>

        <v-row class="mt-1 mb-1 pl-3 pr-3">
            <v-col
                cols="12"
            >
                <v-textarea
                    v-if="selected_target.value === 'suggestion' || selected_target.value === 'interest_2'"
                    dense
                    outlined
                    class="pt-0"
                    v-model="search"
                    :label="search_hint"
                    single-line
                    hide-details
                    style="width:100%;"
                    color="primary"
                    @keydown.enter="searchKeyword(search, $event)"
                ></v-textarea>
                <v-text-field
                    v-else
                    dense
                    outlined
                    class="pt-0"
                    v-model="search"
                    :label="search_hint"
                    single-line
                    hide-details
                    style="width:100%;"
                    color="primary"
                    @keypress.enter="searchKeyword(search, $event)"
                ></v-text-field>
            </v-col>
            <v-col
                cols="12" 
                class="d-flex justify-end"
            >
                <v-btn 
                    @click="searchKeyword(search)"
                    class="ml-3 btn_action btn_action_bg_linear d-flex align-center"
                >
                    <v-icon
                    small
                    class="mr-2"
                    >
                        mdi-magnify
                    </v-icon>
                    <span>搜尋</span>
                </v-btn>
            </v-col>
        </v-row>

		<v-divider></v-divider>
        <v-card-text v-if="selected_target.value === 'suggestion'">
            <h5>興趣字詞匹配程度</h5>

            <v-btn-toggle
                v-model="relatedness"
                dense
                color="primary"
                mandatory
            >
                <v-btn value="0.5">
                    廣泛
                </v-btn>

                <v-btn value="0.7">
                    精準
                </v-btn>
            </v-btn-toggle>
        </v-card-text>
        <v-divider v-if="selected_target.value === 'suggestion'"></v-divider>
        <v-card-text>總共 {{total}} 筆</v-card-text>
		<v-data-table
            ref="table"
			hide-default-footer
			:headers="headers"
			:items="datas"
			:items-per-page="selected_per_page.value"
            :no-data-text="'無資料'"
            :no-results-text="'無資料'"
            :loading="is_loading"
            item-key="$index"
            :loading-text="'載入中'"
            :page="table_page"
            @update:page="pageChange"
		>

			<template v-slot:[`item.valid`] = "{item}">
                <template v-if="item.valid">
                    <v-icon
                        color="success"
                        v-if="item.valid"
                    >
                        mdi-check
                    </v-icon>
                    <v-icon
                        color="error"
                        v-else
                    >
                        mdi-close
                    </v-icon>
                </template>
			</template>

			<template v-slot:[`item.stage`] = "{item}">
                <v-icon
                    color="success"
                    v-if="item.stage"
                >
                    mdi-check
                </v-icon>
                <v-icon
                    color="error"
                    v-else
                >
                    mdi-close
                </v-icon>
			</template>

			<template v-slot:[`item.count`] = "{item}">
                <template v-if="item.count !== null">
                    {{$utils.formatNumberWithCommas(item.count)}}
                </template>
                <template v-else>
                    --
                </template>
			</template>

			<template v-slot:[`item.audience_size`] = "{item}">
                <template v-if="item.audience_size">
                    <div class="d-flex justify-end">
                        {{$utils.formatNumberWithCommas(item.audience_size)}} 人
                    </div>
                    
                </template>
			</template>

			<template v-slot:[`item.created_at`] = "{item}">
                <template v-if="item.created_at">
                    {{$utils.getYYYYMMDDHHMMSS(item.created_at, '-')}} 
                </template>
			</template>

			<template v-slot:[`item.finished_at`] = "{item}">
                <template v-if="item.finished_at">
                    {{$utils.getYYYYMMDDHHMMSS(item.finished_at, '-')}} 
                </template>
			</template>

            <template
                v-slot:[`item.relatedness`] = "{item}"
            >
                <div
                    style="max-width:200px"
                >
                    <v-progress-linear
                        rounded
                        height="24"
                        :value="getPercent(item.relatedness)"
                    >
                    </v-progress-linear>
                </div>

            </template>
		</v-data-table>

		<div class="text-center mt-5">
			<Pagination
                @changePage="changePage"
				v-if="page_setting.is_show"
				:setting="page_setting"
			/>
		</div>
	</v-card>
</template>
<script>
import Pagination from '@/components/Utils/Pagination.vue'
import {
    apiSearchInterst,
    apiSearchSuggestion,
    apiGetInterstHistory,
    apiSearchSeed,
    apiSearchInterstChroma
} from '@/api/optimize.js'

import {
  apiGetSubscriptionInfoWithData
} from '@/api/organize.js'

	export default {
		name: 'SearchList',
		components: {
			Pagination
		},
		data: function() {
			return {	
				search: '',	
				page_title: "興趣搜尋",
				is_loading: false,	
				datas: [],
				headers: [      
					{
						text: '興趣名稱',
						sortable: false,
						value: 'name',
					},
					{
						text: '受眾規模',
						sortable: false,
						value: 'audience_size',
                        
					},
					{
						text: '興趣路徑',
						sortable: false,
						value: 'path',
					},				             
				],
				headers_1: [      
					{
						text: '興趣名稱',
						sortable: false,
						value: 'name',
					},
					{
						text: '受眾規模',
						sortable: false,
						value: 'audience_size',
                        
					},
					{
						text: '興趣路徑',
						sortable: false,
						value: 'path',
					},				             
				],
                headers_2: [
					{
						text: '有效',
						sortable: false,
						value: 'valid',
					},
					{
						text: '興趣名稱',
						sortable: false,
						value: 'name',
					},
					{
						text: '受眾規模',
						sortable: false,
						value: 'audience_size',
                        
					},
					{
						text: '興趣路徑',
						sortable: false,
						value: 'path',
					},	
                ],
                headers_3: [
					{
						text: '名稱',
						sortable: false,
						value: 'id',
					},
					{
						text: '數量',
						sortable: false,
						value: 'count',
                        
					},
					{
						text: '完成',
						sortable: false,
						value: 'stage',
					},
					{
						text: '開始時間',
						sortable: false,
						value: 'created_at',
					},
					{
						text: '完成時間',
						sortable: false,
						value: 'finished_at',
					},		
                ],
                headers_4: [
					{
						text: '有效',
						sortable: false,
						value: 'valid',
					},
					{
						text: '興趣名稱',
						sortable: false,
						value: 'name',
					},
					{
						text: '受眾規模',
						sortable: true,
						value: 'audience_size',
                        algin: 'right'
					},
					{
						text: '關聯性',
						sortable: true,
						value: 'relatedness',
					},
					{
						text: '興趣路徑',
						sortable: false,
						value: 'path',
					},

                ],
				page_setting: {
					is_show: false,
					selected_page: 1,
					total_page: 10,
					total_visible: 5,
                    cursors: null,
				},
                selected_target: {
                    text: "興趣建議",
                    value: "suggestion"
                },
                targets: [
                    {
                        text: "興趣建議",
                        value: "suggestion"
                    },
                    {
                        text: "所有興趣",
                        value: "interest"
                    },
                    {
                        text: "所有興趣(語意)",
                        value: "interest_2"
                    },
                    {
                        text: "種子紀錄",
                        value: "history",
                        level: 'nineder'
                    },
                    {
                        text: "製作種子",
                        value: "seed",
                        level: 'nineder'
                    },
                ],
                relatedness: 0.5,
                search_hint: "請輸入要查詢的 興趣字詞 ...",
				selected_per_page: {
					name: "50筆",
					value: 50, 
				},
				per_page_items: [
					{
						name: "50筆",
						value: 50, 
					},
					{
						name: "100筆",
						value: 100, 
					},
					{
						name: "150筆",
						value: 150, 
					},
					{
						name: "200筆",
						value: 200, 
					},
					{
						name: "250筆",
						value: 250, 
					},
					{
						name: "300筆",
						value: 300, 
					},
				],
                total: 0,
                table_page: 1
			}
		},
		mounted: async function() {
            let tmp_start_at = this.$utils.getYYYYMMDDHHMMSS(this.$utils.calculateDate(-30).toISOString(), '-').split(' ')[0]
            let tmp_end_at = this.$utils.getYYYYMMDDHHMMSS(this.$utils.calculateDate(30).toISOString(), '-').split(' ')[0]
            let result = await apiGetSubscriptionInfoWithData(
                this.$route.params.org_id,tmp_start_at, tmp_end_at
            )
            console.log('quota_result', result)
            if (result.level !== 'nineder') {
                this.targets = this.targets.filter(item => {
                    return item.level !== 'nineder'
                })
            }

            this.initData()
		},
		methods: {
			initData: async function(){
                let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
                let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : 50
                // let keyword = this.$route.query.keyword ? this.$route.query.keyword : ''
                if (isNaN(page_idx)) {
                    page_idx = 1
                }
                if (isNaN(limit)) {
                    limit = 50
                }
                // this.search = keyword
                this.page_setting.selected_page = page_idx
                
                this.selected_per_page = {
					name: `${limit}筆`,
					value: limit, 
                }
                this.searchKeyword(this.search)
            
			},
			chagePerPage: async function(selected_per_page){
				let query = this.$route.query;
				let tmp_query = {...query, limit: selected_per_page.value, page: 1};
				console.log(tmp_query)
				try {
					await this.$router.push({ path: this.$route.path, query: tmp_query})
				} catch (err) {
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				}
				await this.initData()
			},
            // async searchKeyword(keyword, paging_forward, next){
			async searchKeyword(keyword, event, is_page){
                console.log('keyword', keyword)
                console.log('event', event)
                console.log('is_page', is_page)
                console.log(this.selected_target)
                if (event && event.isComposing) {
                    return
                }
                if (this.selected_target.value === 'suggestion' && !keyword){
                    return
                }
                this.is_loading = true
                this.page_setting.is_show = false
                
                let now_page = this.$route.query.page ? this.$route.query.page: 1
                let table = this.$refs['table'].$el
                console.log('table',table)
                let rect = table.getBoundingClientRect()
                window.scrollTo({ top: rect.top-150, behavior: 'smooth' });

                if (this.selected_target.value === 'interest') {
                    try {
                        
                        let params = {
                            key: keyword,
                            semantic: 0,
                            page: is_page ? now_page: 1 ,
                            limit: this.selected_per_page.value,
                        }
                        console.log('params',params)
                        let resp = await apiSearchInterst(
                            this.$route.params.org_id,
                            params
                        )

                        console.log('resp',resp)
                        this.page_setting = {
                            is_show: true,
                            selected_page: is_page ? now_page: 1 ,
                            total_visible: 8,
                            total_page: resp.data.totalPages,
                        }
                        this.datas = resp.data.content
                        this.total = resp.data.totalElements
                    } catch (error) {
                        console.log('i_error',error)
                    }
                }
                else if (this.selected_target.value === 'suggestion'){
                    try {

                        if (is_page) {
                            this.is_loading = false
                            this.table_page = this.page_setting.selected_page
                            this.page_setting.is_show = true
                            return
                        }
                        // let keywords = keyword.split(' ')
                        // let params = {
                        //     "key": keywords,
                        //     "paging_forward": paging_forward,
                        //     "next": next
                        // }
                        // console.log('params',params)
                        let resp = await apiSearchSuggestion(
                            this.$route.params.org_id,
                            keyword,
                            1,
                            this.relatedness
                        )
                        // this.page_setting.keyword = keyword
                        // if (resp.data.paging) {
                        //     this.page_setting.cursors = resp.data.paging.cursors
                        // }
                        // else {
                        //     this.page_setting.cursors = null
                        // }
                        if (resp.data) {
                            this.table_page = 1
                            this.datas = resp.data.interest_data
                            this.page_setting = {
                                is_show: true,
                                selected_page: 1,
                                total_visible: 8,
                                total_page: Math.ceil(this.datas.length / this.selected_per_page.value),
                            }
                        }
                        this.total = this.datas.length

                        
                        console.log('data',this.datas)
                    } catch (error) {
                        this.$root.vtoast.show({
                            message: `興趣搜尋失敗，原因: ${error}`,
                        })
                        console.log('s_error',error)
                    }
                }
                else if (this.selected_target.value === 'history'){
                    try {
                        
                        let resp = await apiGetInterstHistory(
                            this.$route.params.org_id,
                            is_page ? now_page: 1 ,
                            this.selected_per_page.value,
                            keyword ? keyword : '',
                        )
                        console.log('resp',resp)
                        this.page_setting = {
                            is_show: true,
                            selected_page: is_page ? now_page: 1 ,
                            total_visible: 8,
                            total_page: resp.data.totalPages,
                        }
                        this.datas = resp.data.content
                        this.total = resp.data.totalElements
                    } catch (error) {
                        console.log('h_error', error)
                        this.$root.vtoast.show({
                            message: `所有興趣取得失敗，原因: ${error}`,
                        })
                    }
                }
                else if (this.selected_target.value === 'interest_2') {
                    try {
                        
                        let params = {
                            key: keyword,
                            limit: this.selected_per_page.value,
                        }
                        let resp = await apiSearchInterstChroma (
                            this.$route.params.org_id, params
                        )
                        console.log('resp', resp)
                        this.datas = resp.data.content
                        this.total = this.datas.length
                    } catch (error) {
                        console.log('v2_error', error)
                        this.$root.vtoast.show({
                            message: `所有興趣(語意)取得失敗，原因: ${error}`,
                        })
                    }
                    
                }
                else {
                    try {
                        let seeds = keyword.split(',')
                        let params = {
                            "seeds": seeds
                        }
                        if (keyword) {
                            let resp = await apiSearchSeed(
                                this.$route.params.org_id, params
                            )
                            console.log('resp', resp)
                            this.$root.vtoast.show({
                                message: `種子加入成功，將會開始進行搜尋，可以在種子紀錄中查詢到。`,
                            })
                        }

                    } catch (error) {
                        console.log('s_error', error)
                        this.$root.vtoast.show({
                            message: `種子加入失敗，原因: ${error}`,
                        })
                    }
                }


                // if (this.page_setting.cursors) {
                //     let next_resp = null
                //     let prev_resp = null
                //     try {
                //         let keywords = keyword.split(' ')
                //         let params = {
                //             "key": keywords,
                //             "paging_forward": paging_forward,
                //             "next": next
                //         }
                //         console.log('params',params)
                //         params['paging_forward'] = 'after'
                //         params['next'] = this.page_setting.cursors.after
                //         next_resp = await apiSearchSuggestion(
                //             this.$route.params.org_id,
                //             params
                //         ) 
                //         params['paging_forward'] = 'before'
                //         params['next'] = this.page_setting.cursors.before
                //         prev_resp = await apiSearchSuggestion(
                //             this.$route.params.org_id,
                //             params
                //         )  
                //         console.log('next_resp', next_resp)
                //         console.log('prev_resp', prev_resp)
                //     } catch (error) {
                //         console.log('hide', error)
                //     }

                //     if (next_resp.data.data.length > 0) {
                //         console.log('1.有下一頁')
                //         this.page_setting.is_show = true

                //         if (prev_resp.data.data.length > 0) {
                //             console.log('2.有上一頁')
                //             this.page_setting.selected_page = 1
                //             this.page_setting.total_page = 2
                //             this.page_setting.total_visible = 0
                //         }
                //         else {
                //             console.log('2.沒上一頁')
                //             this.page_setting.selected_page = 0
                //             this.page_setting.total_page = 1
                //             this.page_setting.total_visible = 0
                //         }
                //     }
                //     else {
                //         console.log('1.沒有下一頁')
                //         this.page_setting.is_show = true
                //         if (prev_resp.data.data.length > 0) {
                //             console.log('2.有上一頁')
                //             this.page_setting.selected_page = 2
                //             this.page_setting.total_page = 2
                //             this.page_setting.total_visible = 0
                //         }
                //         else {
                //             console.log('2.沒有上一頁')
                //             this.page_setting.selected_page = 0
                //             this.page_setting.total_page = 0
                //             this.page_setting.total_visible = 0
                //         }
                //     }
   
                // }
                // else {
                //     this.page_setting.is_show = true
                //     this.page_setting.selected_page = 0
                //     this.page_setting.total_page = 0
                //     this.page_setting.total_visible = 0
                // }
                this.is_loading = false
			},
            async changePage(page_idx){
                console.log(this.page_setting)
                console.log('page_idx',page_idx)
                // let type = ''
                // let key = ''
                // if (this.page_setting.cursors) {
                //     if (this.page_setting.selected_page > page_idx) {
                //         type = 'before'
                //         key = this.page_setting.cursors.before
                //     }
                //     else {
                //         type = 'after'
                //         key = this.page_setting.cursors.after
                //     }
                // }

                this.page_setting.selected_page = page_idx

                this.searchKeyword(
                    this.search, '', true
                )
                
            },
            async changeType(){
                console.log(this.selected_target)
                this.datas = []
                this.page_setting.is_show = false
                this.search = ''
                this.search_hint = "請輸入要查詢的 興趣字詞 ..."
                this.total = 0
                this.table_page = 1
                try {
                    await this.$router.replace(`/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_site/interesting_search/`)
                } catch (error) {
                    console.log('error',error)
                }
                if (this.selected_target.value === 'suggestion') {                    
                    this.page_setting.selected_page = 1
                    this.headers = this.headers_1
                }
                else if (this.selected_target.value === 'interest'){
                    this.headers = this.headers_2
                }
                else if (this.selected_target.value === 'history'){
                    this.headers = this.headers_3
                }
                else if (this.selected_target.value === 'seed'){
                    this.search_hint = '用,一次製作多個，例如: 籃球,運動'
                }
                else if (this.selected_target.value === 'interest_2') {
                    this.headers = this.headers_4
                }

                this.searchKeyword(this.search)
            },
            getPercent(relatedness) {
                let percent = 0
                if (relatedness) {
                    percent = parseInt(relatedness * 100)
                }
                return percent
            },
            pageChange(){
                let table = this.$refs['table'].$el
                let rect = table.getBoundingClientRect()
                window.scrollTo({ top: rect.top-150, behavior: 'smooth' })

            }
            
		},	
		computed: {
		}     
	}
</script>
<style scoped>
</style>